import { Routes } from '@angular/router';
import { noAuthGuard } from './core/guards/no-auth-guard';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: '',
    canActivate: [noAuthGuard],
    loadComponent: () => import('./core/components/auth/auth.component')
      .then(x => x.AuthComponent),
  },
  {
    // New guided registration → KYC → agent-enrollment wizard.
    path: 'register',
    loadComponent: () => import('./onboarding/onboarding.component')
      .then((x) => x.OnboardingComponent),
  },
  {
    path: 'auth',
    canActivate: [MsalGuard],
    loadChildren: () => import('../app/customers-onboarding/routes/customer-onboarding.routes')
      .then((r) => r.customerOnboardingRoutes)
  }
];
